module.exports = __webpack_public_path__ + "img/haiwaichuangxinzhongxinE.1d6cb048.png";